import weatherAPP from "./Images/weather-app.png";
import CalculatorImage from "./Images/Calculator App.png";
import PortfolioImage from "./Images/portfolioImage.png";
import ToDoList from "./Images/todolist.png";
import EcommerceWebsite from "./Images/e-comm app.png";

const ProjectList = [
	{
		title: "Weather App",
		description:
			'Weather App is a comprehensive weather app designed to provide users with detailed meteorological information for any location. With features including maximum, minimum, and current temperatures, as well as humidity and windspeed data, users can gain insight into the current and forecasted weather conditions. The app also calculates the "feels like" temperature, taking into account factors such as humidity and windspeed to offer a more holistic view of the weather. Additionally, Weather App includes a date and time display for added convenience in planning activities. Whether users are preparing for outdoor adventures or simply staying informed about their local climate, Weather App offers a user-friendly interface and accurate data to meet their needs.',
		src: weatherAPP,
		link: "https://github.com/kritibagga/Weather-Application",
		tech: [
			"https://img.icons8.com/?size=80&id=jwnY8EWCnF6k&format=png",
			"https://img.icons8.com/?size=64&id=107497&format=png",
			"https://img.icons8.com/?size=64&id=gYCTehfTlYk5&format=png",
			"https://img.icons8.com/?size=80&id=wPohyHO_qO1a&format=png",
			"https://img.icons8.com/?size=80&id=Oz14KBnT7lnn&format=png",
		],
	},
	{
		title: "Calculator",
		description:
			"Introducing a straightforward calculator app with essential functions for seamless mathematical operations. This app supports basic arithmetic – addition, subtraction, multiplication, and division – alongside decimal values and percentage calculations. Users can invert values and reset inputs effortlessly, enhancing flexibility and usability. Larger numbers are formatted for clarity, and the output dynamically resizes based on the result's length, ensuring optimal visibility on any device. Whether you're a student, professional, or everyday user, this calculator simplifies complex computations with its intuitive design and practical features, making it an indispensable tool for anyone needing swift and accurate calculations.",
		src: CalculatorImage,
		link: "https://github.com/kritibagga/Calculator",
		tech: [
			"https://img.icons8.com/?size=80&id=jwnY8EWCnF6k&format=png",
			"https://img.icons8.com/?size=64&id=107497&format=png",
			"https://img.icons8.com/?size=64&id=gYCTehfTlYk5&format=png",
			"https://img.icons8.com/?size=80&id=wPohyHO_qO1a&format=png",
			"https://img.icons8.com/?size=80&id=Oz14KBnT7lnn&format=png",
		],
	},
	{
		title: "Portfolio",
		description:
			"Welcome to my portfolio website, your window into my creative journey. The homepage greets you with a captivating design, setting the stage for what lies ahead. Explore my projects through the project list section, where each piece is showcased with a brief description of its significance. Get to know me better in the 'About Me' section, where I share insights into my background, skills, and aspirations. Looking to connect? The contact section provides an easy way to reach out for collaboration, inquiries, or just a friendly chat. With a seamless blend of design, functionality, and personal touch, my portfolio offers a glimpse into my passion for creativity and innovation.",
		src: PortfolioImage,
		link: "https://github.com/kritibagga/Portfolio-Website",
		tech: [
			"https://img.icons8.com/?size=80&id=jwnY8EWCnF6k&format=png",
			"https://img.icons8.com/?size=64&id=107497&format=png",
			"https://img.icons8.com/?size=64&id=gYCTehfTlYk5&format=png",
			"https://img.icons8.com/?size=80&id=wPohyHO_qO1a&format=png",
			"https://img.icons8.com/?size=80&id=6An5AOhd2jp7&format=png",
		],
	},
	{
		title: "To Do List",
		description:
			"This project aims to develop a ToDo List web application using Node.js, Express.js, and EJS. Its core functionality includes task creation and viewing, with the ability for users to mark tasks as completed without deleting them. Additionally, the application will feature segmented lists, allowing users to organize tasks into distinct categories such as daily tasks and work-related assignments. A key focus will be on styling, ensuring an aesthetically pleasing and responsive interface for optimal user experience across both desktop and mobile devices. While tasks won't persist between sessions in this version, the emphasis on usability and visual appeal aims to provide users with a seamless and enjoyable task management experience.",
		src: ToDoList,
		link: "https://github.com/kritibagga/todolist",
		tech: [
			"https://img.icons8.com/?size=80&id=jwnY8EWCnF6k&format=png",
			"https://img.icons8.com/?size=64&id=107497&format=png",
			"https://img.icons8.com/?size=64&id=gYCTehfTlYk5&format=png",
			"https://img.icons8.com/?size=64&id=2ZOaTclOqD4q&format=png",
			"https://img.icons8.com/?size=64&id=ouWtcsgDBiwO&format=png",
		],
	},
	{
		title: "E-Comm App",
		description:
			"The ecommerce-app simplifies online shopping with a user-friendly interface. Its product listing page showcases items with titles, images, descriptions, prices, and quantities, adapting seamlessly to various screen sizes. Pagination enables effortless navigation through product sets, while a dynamic shopping cart icon updates with added items. Clicking the icon leads to a detailed cart page displaying quantities, prices, and a remove option. A clear cart button facilitates easy removal of all items, and the total payable amount is prominently displayed for transparency. Note: Some elements like headers and footers are static and non-functional.",
		src: EcommerceWebsite,
		link: "https://github.com/kritibagga/ecommerce-app",
		tech: [
			"https://img.icons8.com/?size=80&id=jwnY8EWCnF6k&format=png",
			"https://img.icons8.com/?size=64&id=107497&format=png",
			"https://img.icons8.com/?size=64&id=gYCTehfTlYk5&format=png",
			"https://img.icons8.com/?size=80&id=wPohyHO_qO1a&format=png",
			"https://img.icons8.com/?size=80&id=Oz14KBnT7lnn&format=png",
		],
	},
];

export default ProjectList;
